import { SvgIcon, SvgIconProps } from '@mui/material'

export function DevicesIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16663 1.66667C4.16663 1.39053 4.39048 1.16667 4.66663 1.16667H14.3333C14.6094 1.16667 14.8333 1.39053 14.8333 1.66667V14.3333C14.8333 14.6095 14.6094 14.8333 14.3333 14.8333H7.66663V13.8333H13.8333V2.16667H5.16663V5H4.16663V1.66667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16663 5C1.16663 4.72386 1.39048 4.5 1.66663 4.5H7.66663C7.94277 4.5 8.16663 4.72386 8.16663 5V14.3333C8.16663 14.6095 7.94277 14.8333 7.66663 14.8333H1.66663C1.39048 14.8333 1.16663 14.6095 1.16663 14.3333V5ZM2.16663 5.5V13.8333H7.16663V5.5H2.16663Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83337 12.3333C3.83337 12.0572 4.05723 11.8333 4.33337 11.8333H5.00004C5.27618 11.8333 5.50004 12.0572 5.50004 12.3333C5.50004 12.6095 5.27618 12.8333 5.00004 12.8333H4.33337C4.05723 12.8333 3.83337 12.6095 3.83337 12.3333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83337 12.3333C8.83337 12.0572 9.05723 11.8333 9.33337 11.8333H10C10.2762 11.8333 10.5 12.0572 10.5 12.3333C10.5 12.6095 10.2762 12.8333 10 12.8333H9.33337C9.05723 12.8333 8.83337 12.6095 8.83337 12.3333Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default DevicesIcon
